import { useEffect, useState } from 'react';
import { breakpoints } from '@amzn/stencil-design-tokens/js/web/utils';

/**
 * Tracks whether the viewport is at or below the stencil small
 * breakpoint. Used by sheets/modals that render as a centered Modal
 * on desktop and a BottomSheet on mobile.
 *
 * Subscribes to the media query so the value stays live across
 * orientation changes and window resizes.
 */
export function useIsMobile(): boolean {
  const query = `(max-width: ${breakpoints.s.max}px)`;
  const [mobile, setMobile] = useState(() => window.matchMedia(query).matches);

  useEffect(() => {
    const mql = window.matchMedia(query);
    const handler = (e: MediaQueryListEvent): void => setMobile(e.matches);
    mql.addEventListener('change', handler);
    return () => mql.removeEventListener('change', handler);
  }, [query]);

  return mobile;
}
